import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type {
  CollectingRequestsCancelSummary,
  PostCollectingRequestsCancelParams,
  PostCollectingRequestsCancelResponse,
} from '~/types/delivery-agency.types';

const fetchPostCollectingRequestsCancel = async (
  params: PostCollectingRequestsCancelParams
): Promise<CollectingRequestsCancelSummary> => {
  const { data } = await axiosInstance.post<PostCollectingRequestsCancelResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.POST_COLLECTING_REQUESTS_CANCEL,
    params
  );
  return data.data;
};

export const usePostCollectingRequestsCancelMutation = () => {
  return useMutation<
    CollectingRequestsCancelSummary,
    TypeErrorResponseData['error'],
    PostCollectingRequestsCancelParams
  >({
    mutationFn: fetchPostCollectingRequestsCancel,
    meta: { showGlobalErrorToast: false },
  });
};

registerMockAPI<PostCollectingRequestsCancelResponse | TypeErrorResponseData>({
  method: 'post',
  endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_COLLECTING_REQUESTS_CANCEL,
  label: '배송 주문 반품 신청·조회/반품 취소',
  scenarios: [
    {
      name: '전건 성공',
      response: { data: { totalCount: 2, successCount: 2, failureCount: 0, message: '' } },
    },
    {
      name: '부분 실패',
      response: {
        data: {
          totalCount: 2,
          successCount: 1,
          failureCount: 1,
          message: '',
        },
      },
    },
    {
      name: '전건 실패',
      response: {
        data: {
          totalCount: 2,
          successCount: 0,
          failureCount: 2,
          message: '',
        },
      },
    },
    {
      name: '팝업 공통 에러 (61000) — 얼럿',
      status: 400,
      response: {
        error: { code: 61000, message: '회수 중인 반품요청번호는 취소할 수 없습니다.\n배송사에 문의해 주세요.' },
      },
    },
    {
      name: '일반 에러 (400) — 토스트',
      status: 400,
      response: { error: { code: 40000, message: '반품 취소 처리 중 오류가 발생했습니다.' } },
    },
  ],
});
